/* eslint-disable arrow-body-style */
import { commonError, TIMEOUT, defaultLocateConfig, getCurrentPosition } from './location';
import { getBaiduAPI, isWechatMiniProgramBrowser, isAlipayMiniProgramBrowser } from './common-helper';
import { MAP_TYPE } from './const';
import { formatMessage } from '../intl/helper';
import actionText3 from '../intl/messages/action/part3';

const BMap = window.BMap;

/**
 * 百度定位，拿到的百度坐标
 * @export
 * @param {object|undefined} [config={}]
 * @returns
 */
export function baiduLocation(config = {}) {
  return new Promise((resolve, reject) => {
    const geolocation = new BMap.Geolocation();
    geolocation.getCurrentPosition(
      result => {
        if (result && result.point) {
          resolve(result.point);
        } else {
          reject(commonError);
        }
      },
      {
        ...defaultLocateConfig,
        ...config,
      },
    );
  });
}

// 将其他坐标系的坐标转换为百度坐标
export const convertToBaiduPoint = position =>
  new Promise((resolve, reject) => {
    const convertor = new BMap.Convertor();
    const pointArr = [new BMap.Point(position.longitude, position.latitude)];
    // 将其它坐标转为百度坐标
    convertor.translate(pointArr, 1, 5, (data = {}) => {
      if (data.status === 0) {
        resolve(data.points[0]);
      } else {
        reject(commonError);
      }
    });
  });

// 不直接拿百度地图的坐标，而是用转换的方式拿（原有逻辑）
export const getLocation = config =>
  getCurrentPosition(config)
    .then(position => convertToBaiduPoint(position))
    .catch(error => {
      // 定位错误、转换错误再尝试使用百度定位
      if (error.code !== TIMEOUT) {
        return baiduLocation(config);
      }

      throw error;
    });

// 获取转换过后的地址信息(百度地图)
export const transformPointToAddress = position =>
  new Promise((resolve, reject) => {
    const geocoder = new BMap.Geocoder();
    // 将坐标转义到 省市街道 等信息
    geocoder.getLocation(position, result => {
      if (result) {
        const { addressComponents, point, address } = result;
        resolve({
          city: addressComponents.city,
          longitude: `${point.lng}`,
          latitude: `${point.lat}`,
          province: addressComponents.province,
          district: addressComponents.district,
          street: addressComponents.street,
          address,
          mapType: MAP_TYPE.B_MAP,
        });
      } else {
        reject({
          code: 4,
          message: formatMessage(actionText3.actionlocateFailedAndRefresh),
        });
      }
    });
  });

// 定位 & 获取位置信息
export const getTransformedLocation = config => getLocation(config).then(position => transformPointToAddress(position));

// 根据坐标获取位置信息
export const getAddressByPoint = point => {
  const bMapPoint = new BMap.Point(Number(point.longitude), Number(point.latitude));
  return transformPointToAddress(bMapPoint);
};

// 跳转百度地图查看导航
export const checkGuideOnMap = ({ cityName, commercialAdress, latlong }) =>
  getTransformedLocation().then(position => {
    getBaiduAPI(
      {
        city: position.city,
        latlng: `${position.latitude},${position.longitude}`,
      },
      {
        city: cityName,
        commercialAdress,
        latlng: latlong,
      },
    );
  });

// 在百度地图上查看地址
export const checkPositionOnMap = ({ latlong, commercialName, commercialAdress }) => {
  document.location.href = `http://api.map.baidu.com/marker?location=${latlong}&title=${encodeURIComponent(commercialName)}&content=${encodeURIComponent(
    commercialAdress,
  )}&output=html&src=客如云`;
};

// 根据地址获取百度地图坐标
export const getPoint = (address, city) =>
  new Promise((resolve, reject) => {
    const geocoder = new BMap.Geocoder();
    geocoder.getPoint(
      address,
      point => {
        if (point) {
          resolve(point);
        } else {
          reject();
        }
      },
      city,
    );
  });

// 获取附近poi列表（百度地图）
export const getPoiList = (position, config = {}) =>
  convertToBaiduPoint(position).then(
    point =>
      new Promise((resolve, reject) => {
        const geocoder = new BMap.Geocoder();
        // 获取poi列表
        geocoder.getLocation(
          point,
          result => {
            if (result) {
              const { surroundingPois = [] } = result;
              resolve(
                surroundingPois.map(poi => {
                  const poiPoint = poi.point || {};
                  return {
                    title: poi.title,
                    address: poi.address,
                    uid: poi.uid,
                    longitude: poiPoint.lng,
                    latitude: poiPoint.lat,
                  };
                }),
              );
            } else {
              reject({
                code: 4,
                message: formatMessage(actionText3.actionlocateFailedAndRefresh),
              });
            }
          },
          { poiRadius: 500, numPois: 10, ...config },
        );
      }),
  );
  // 判断是否是小程序环境（屏蔽地图调用入口）
export const isMiniProgramBrowser = () => {
  return isAlipayMiniProgramBrowser() || isWechatMiniProgramBrowser();
};



// WEBPACK FOOTER //
// ./src/helper/map.js